import React from 'react'

import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from 'components/ui-builder/common/button'
import RecipeLister, { IProps, RecipeListerProps } from 'components/ui-builder/recipe-lister'

import './recipe.css'

export interface IRecipeListerProps extends IProps {
  listerTitle: string
  listerTitleColor: string
  listerFirstBGColor: string
  listerBgColor: string
  buttonProps: LinkButtonProp
}

const RecipeListerWrapper = ({
  articleDescriptionTextColor,
  articleItemBackgroundColor,
  articleTitleTextColor,
  autoplayTime,
  backgroundColor,
  maxNumberOfFeature,
  maxNumberToList,
  recipeBulletPoint,
  listerTitle,
  listerTitleColor,
  listerFirstBGColor,
  listerBgColor,
  buttonProps
}: IRecipeListerProps) => {
  return (
    <div className="relative w-full" style={{ backgroundColor: listerBgColor }}>
      <div className="bg-wrap index-0 absolute top-0 h-1/2 w-full" style={{ backgroundColor: listerFirstBGColor }} />
      <div className="lister-title index-1 relative p-4 pt-10 text-center sm:pb-0 sm:pl-0 sm:pr-0">
        <h2 style={{ color: listerTitleColor }}>{listerTitle}</h2>
      </div>
      <div className="index-1 mb-10">
        <RecipeLister
          articleItemBackgroundColor={articleItemBackgroundColor}
          articleDescriptionTextColor={articleDescriptionTextColor}
          articleTitleTextColor={articleTitleTextColor}
          autoplayTime={autoplayTime}
          backgroundColor={'transparent'}
          maxNumberOfFeature={maxNumberOfFeature}
          maxNumberToList={maxNumberToList}
          recipeBulletPoint={recipeBulletPoint}
        />
      </div>
      <div className="w-full p-4 text-center">
        <LinkButton
          buttonColor={buttonProps?.buttonColor}
          buttonText={buttonProps?.buttonText}
          buttonTextColor={buttonProps?.buttonTextColor}
          loggedInButtonText={buttonProps?.loggedInButtonText}
          buttonUrl={buttonProps?.buttonUrl}
          isLink={buttonProps?.isLink}
          classList={
            'inline-block bg-white py-2 px-4 border border-transparent rounded-full text-base font-medium text-indigo-600 hover:bg-indigo-50 shadow w-full sm:w-fit'
          }
        />
      </div>
    </div>
  )
}

export default RecipeListerWrapper

export const RecipeListerWrapperProps = {
  name: 'recipeListerWrapperProps',
  type: 'object',
  subFields: [
    ...RecipeListerProps.inputs,
    {
      name: 'listerTitle',
      type: 'text',
      defaultValue: 'We think you’ll like these recipes too'
    },
    {
      name: 'listerTitleColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'listerFirstBGColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      name: 'listerBgColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      ...LinkButtonRegisterProps
    }
  ]
}
